import { COLORS_ACTOR } from './actorColors';

/**
 * Color amb què es marca cada persona connectada.
 *
 * Ha de ser **estable**: la mateixa persona ha de sortir del mateix color a
 * l'indicador de dalt, a l'anell que envolta el que té seleccionat al llenç i a
 * l'etiqueta amb el seu nom. Per això surt del seu identificador i no de
 * l'ordre en què s'ha connectat: si depengués de l'ordre, els colors ballarien
 * cada cop que algú entra o surt.
 *
 * Reaprofita la paleta dels actors, que ja està validada perquè els colors es
 * distingeixin entre ells i perquè el text blanc s'hi llegeixi a sobre.
 */
export const colorDePersona = (userId) => {
  const n = Number(userId) || 0;
  return COLORS_ACTOR[n % COLORS_ACTOR.length];
};

/** Inicials per a l'avatar rodó. */
export const inicialsDePersona = (persona) => {
  const nom = persona?.full_name || persona?.username || '';
  const parts = nom.split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  return parts.slice(0, 2).map(p => p[0].toUpperCase()).join('');
};
